module.exports = __webpack_public_path__ + "static/media/alarm.0f607c6b.mp3";